var _linearGradient, _path, _path2, _path3, _path4, _path5, _linearGradient2, _path6, _linearGradient3, _path7;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBankTransactions(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 198.425 198.425",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _linearGradient || (_linearGradient = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_0_b66bf25b8a4557f1a6067cfb8226a0a80d0ab0316cfb19b7cfc5c526b05b4e88",
    gradientUnits: "userSpaceOnUse",
    x1: -3069.771,
    y1: -13.591,
    x2: -3068.771,
    y2: -13.591
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "var(--icon-menu-gradient-start, #7a0399)"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.632,
    stopColor: "var(--icon-menu-gradient-end, #b10372)"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "MI_4L_main",
    d: "M68.322 50.638v9.292M60.015 50.638v9.292M68.322 109.278v9.04M60.015 109.278v9.04M128.161 50.638v67.941M136.956 50.638v67.941M103.197 50.638v67.941M93.913 50.638v67.941M99.723 33.529s-.517-2.989-2.989-2.989-3.137 2.989-3.137 2.989l6.421 4.868"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "MI_4L_main",
    d: "M93.892 38.397s.517 2.989 2.989 2.989 3.137-2.989 3.137-2.989M96.808 27.993v2.547M96.808 41.386v2.547"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "MI_4L_stroke",
    d: "M99.723 33.529s-.517-2.989-2.989-2.989-3.137 2.989-3.137 2.989l6.421 4.868"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "MI_4L_stroke",
    d: "M93.892 38.397s.517 2.989 2.989 2.989 3.137-2.989 3.137-2.989M96.808 27.993v2.547M96.808 41.386v2.547"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "MI_4L_main",
    d: "M44.954 50.638h105.525L97.953 17.632zM51.42 118.562h94.789v10.749H51.42z"
  })), _linearGradient2 || (_linearGradient2 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_1_b66bf25b8a4557f1a6067cfb8226a0a80d0ab0316cfb19b7cfc5c526b05b4e88",
    gradientUnits: "userSpaceOnUse",
    x1: 47.694,
    y1: 97.145,
    x2: 90.374,
    y2: 97.145
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "var(--icon-menu-gradient-start, #7a0399)"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.632,
    stopColor: "var(--icon-menu-gradient-end, #b10372)"
  }))), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "url(#SVGID_1_b66bf25b8a4557f1a6067cfb8226a0a80d0ab0316cfb19b7cfc5c526b05b4e88)",
    strokeWidth: 2.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    d: "M48.944 93.317v7.818h26.825v9.446l13.355-14.006-13.681-12.867v9.609z"
  })), _linearGradient3 || (_linearGradient3 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_2_b66bf25b8a4557f1a6067cfb8226a0a80d0ab0316cfb19b7cfc5c526b05b4e88",
    gradientUnits: "userSpaceOnUse",
    x1: 33.965,
    y1: 71.575,
    x2: 76.644,
    y2: 71.575
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "var(--icon-menu-gradient-start, #7a0399)"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.632,
    stopColor: "var(--icon-menu-gradient-end, #b10372)"
  }))), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "url(#SVGID_2_b66bf25b8a4557f1a6067cfb8226a0a80d0ab0316cfb19b7cfc5c526b05b4e88)",
    strokeWidth: 2.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    d: "M75.394 75.402v-7.818H48.57v-9.446L35.215 72.145l13.68 12.866v-9.609z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBankTransactions);
export default __webpack_public_path__ + "static/media/bankTransactions.cb8e2cfd8a330d3f569148a8993161bc.svg";
export { ForwardRef as ReactComponent };